import { ESIGN_MESSAGES, INTEGRATION_TYPES } from '@/constants/esignature';

export const scrollToInvalidVariablesAlert = () => {
  const element = document.querySelector('#invalid-variables-alert');
  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  });
};

export const handleApiError = (
  response: any,
  toast: any,
  defaultTitle: string
) => {
  const errorMsg = Array.isArray(response?.error)
    ? response.error?.[0].split(': ')
    : [];
  const message = errorMsg?.[1] || response?.error?.[0];

  toast({
    title: defaultTitle,
    description: message,
    status: 'error',
  });
};

export const getUpdateErrorMessage = (integrationType: string): string => {
  switch (integrationType) {
    case INTEGRATION_TYPES.PANDADOC:
      return ESIGN_MESSAGES.UPDATE_ERROR.PANDADOC;
    case INTEGRATION_TYPES.ADOBE:
      return ESIGN_MESSAGES.UPDATE_ERROR.ADOBE;
    case INTEGRATION_TYPES.DOCUSIGN:
    default:
      return ESIGN_MESSAGES.UPDATE_ERROR.DOCUSIGN;
  }
};

export const getUpdateSuccessMessage = (integrationType: string): string => {
  switch (integrationType) {
    case INTEGRATION_TYPES.PANDADOC:
      return ESIGN_MESSAGES.UPDATE_SUCCESS.PANDADOC;
    case INTEGRATION_TYPES.ADOBE:
      return ESIGN_MESSAGES.UPDATE_SUCCESS.ADOBE;
    case INTEGRATION_TYPES.DOCUSIGN:
    default:
      return ESIGN_MESSAGES.UPDATE_SUCCESS.DOCUSIGN;
  }
};

export const getHeaderText = (
  integrationType: string,
  isAdmin: boolean
): string => {
  if (!isAdmin) {
    return ESIGN_MESSAGES.HEADER.NON_ADMIN;
  }

  switch (integrationType) {
    case INTEGRATION_TYPES.PANDADOC:
      return ESIGN_MESSAGES.HEADER.PANDADOC_ADMIN;
    case INTEGRATION_TYPES.ADOBE:
      return ESIGN_MESSAGES.HEADER.ADOBE_ADMIN;
    case INTEGRATION_TYPES.DOCUSIGN:
    default:
      return ESIGN_MESSAGES.HEADER.DOCUSIGN_ADMIN;
  }
};
